"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const Heading_1 = require("../Heading");
const StyledHeading = (0, styled_1.default)(Heading_1.Heading)({
    gridArea: 'Header',
    padding: `${constants_1.theme.spacing[3]}px ${constants_1.theme.spacing[3]}px`,
});
const Header = ({ title, color = constants_1.Color.CHARCOAL, }) => {
    return ((0, jsx_runtime_1.jsx)(StyledHeading, { my: "auto", level: 4, color: color, children: title }));
};
exports.Header = Header;
